import styled from 'styled-components/macro';
import { Button } from '@la/ds-ui-components';

export const MakePaymentButton = styled(Button)`
  font: var(--ui-xtra-large-bold);
  padding: 12px;
`;
